import React, { useState, useContext } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useFirestore } from "../../firebase/FirestoreContext";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { EnvContext } from "../../../context/EnvContext";
import config from "../../../config";

const NewModal = ({}) => {
  const environment = useContext(EnvContext);
  const db = useFirestore();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    startDate: "",
    endDate: "",
    actionButtonText: "",
    actionUrl: "",
    showOnce: false,
  });

  const { fetchModals } = useOutletContext();

  const collectionPath = environment === "staging" ? config.enveironment.staging.collectionPath : config.enveironment.production.collectionPath;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addDoc(collection(db, `${collectionPath}Modals/CustomModals/DataBase`), {
      ...formData,
    });
    fetchModals();
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2>Insert New Modal</h2>
      </div>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Title:</label>
          <input type="text" name="title" value={formData.title} onChange={handleChange} style={styles.input} />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Content:</label>
          <textarea name="content" value={formData.content} onChange={handleChange} style={styles.textarea} />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Target URL:</label>
          <input type="text" name="targetUrl" value={formData.targetUrl} onChange={handleChange} style={styles.input} />
          <small style={styles.helperText}>e.g., Listing/LYRTaOxwuevmXGJn1xxz_FTLCgZhDhRM8KdeOC7yM</small>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Action Button Text:</label>
          <input type="text" name="actionButtonText" value={formData.actionButtonText} onChange={handleChange} style={styles.input} />
        </div>

        <div style={styles.formActions}>
          <button
            type="button"
            style={{ ...styles.button, backgroundColor: "siver", marginRight: 5 }}
            onClick={() => {
              // empty all form fields
              setFormData({
                title: "",
                content: "",
                actionButtonText: "",
                acrive: false,
              });
              // navigate
              navigate("/main/modals");
            }}
          >
            Cancel
          </button>
          <button type="submit" style={styles.button}>
            Save Modal
          </button>
        </div>
      </form>
    </div>
  );
};

const styles = {
  container: { margin: "0 auto", padding: "20px", backgroundColor: "#f9f9f9", borderRadius: "8px" },
  header: { marginBottom: "20px", borderBottom: "1px solid #ccc", paddingBottom: "10px" },
  form: { display: "flex", flexDirection: "column", gap: "15px" },
  formGroup: { display: "flex", flexDirection: "column", gap: "5px" },
  label: { fontSize: "14px", fontWeight: "bold" },
  input: { padding: "10px", fontSize: "14px", border: "1px solid #ccc", borderRadius: "4px" },
  textarea: { padding: "10px", fontSize: "14px", border: "1px solid #ccc", borderRadius: "4px", minHeight: "80px" },
  checkbox: { transform: "scale(1.2)" },
  formActions: { display: "flex", justifyContent: "flex-end" },
  button: { backgroundColor: "black", color: "white", border: "none", padding: "10px 20px", cursor: "pointer", borderRadius: "4px" },
};

export default NewModal;
